import CrudController from "./crud_controller";

export default class extends CrudController {
  connect() {
    this.siteNum = this.data.get("siteNum");
    this.agencySearch = this.data.get("agencySearch");
    //this.loadList();
  }

  loadList() {
    this.clearMessage();
    this.fetchForTarget(window.App.prefixedUrl(`/sites/${this.siteNum}/agencies/${this.agencySearch}/permits`), this.listTarget);
  }

  new(event) {

    let div = document.createElement("div");
    div.classList.add("circle-loader");

    let button = event.target.closest("button");

    button.replaceWith(div);

    this.clearMessage();
    this.fetchForTarget(window.App.prefixedUrl(`/sites/${this.siteNum}/agencies/${this.agencySearch}/permits/new`), this.listTarget)
      .then(() => {
        App.applyFlatpickr();
        div.replaceWith(button);
      });
  }
}